import UrlFunctions from "./url"

const GrowthChannel = (content) => {
  const growthChannel =
    UrlFunctions.getParams().sqf_channel || UrlFunctions.getParams().utm_id
  const growthChannelDetails = UrlFunctions.getParams().growthchanneldetails
  let growthChannelItem = []

  if (content && growthChannel) {
    growthChannelItem = content.filter(
      (item) =>
        item.sqf_channel.toLowerCase() === growthChannel.toLowerCase() &&
        item.growth_channel_details?.toLowerCase() ===
          growthChannelDetails?.toLowerCase()
    )
    if (growthChannelItem.length === 0) {
      growthChannelItem = content.filter(
        (item) =>
          item.sqf_channel.toLowerCase() === growthChannel.toLowerCase() &&
          !item.growth_channel_details
      )
    }
  }

  return growthChannelItem[0]
}

export default GrowthChannel
